import { render, staticRenderFns } from "./listRoster.vue?vue&type=template&id=8c7d8bec&scoped=true"
import script from "./listRoster.vue?vue&type=script&lang=js"
export * from "./listRoster.vue?vue&type=script&lang=js"
import style0 from "./listRoster.vue?vue&type=style&index=0&id=8c7d8bec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7d8bec",
  null
  
)

export default component.exports